export default (dataToTracking) => {
  return {
    event: 'promotionImpression',
    route: dataToTracking.route,
    pnr: dataToTracking.pnr,
    ticketNumber: dataToTracking.ticketNumber,
    ecommerce: {
      promoView: {
        promotions: [{
          name: 'Protection Flight',
          id: dataToTracking.id,
          creative: 'Reserve change',
          position: 'MYB',
        }],
      },
    },
  };
};